import React from "react";
import { InputWrapper } from "./styles";

export default ({
	onChange = () => {},
	onFocus = () => {},
	onKeyUp = () => {},
	type = "text",
	placeholder = "",
	errorObj = { message: "", error: false },
	value = null,
}) => {
	return (
		<InputWrapper error={errorObj.error}>
			<input
				autoComplete="off"
				type={type}
				placeholder={placeholder}
				onChange={onChange}
				onFocus={onFocus}
				onKeyUp={onKeyUp}
				value={value}
			/>
			<span className="errorMessageWrapper">
				<i className="errorIcon">!</i>
				<label className="errorMessage">{errorObj.message}</label>
			</span>
		</InputWrapper>
	);
};
